import React, { useState, useEffect } from 'react';
import OrderList from '../components/OrderList/OrderList';
import { setToken, requestData } from '../services/request';
import './Orders.css';

function Orders() {
  const [orders, setOrders] = useState([]);
  const [filtredOrders, setFiltredOrders] = useState([]);
  const [id, setId] = useState('');
  const [loading, setLoading] = useState(true);
  
  const getOrders = async (data) => {
    const { user, token } = data;
    setToken(token);
    if (user.role !== 'admin' && user.role !== 'seller') {
      const result = await requestData(`/orders/my-orders`, user._id);
      setOrders(result);
      setFiltredOrders(result);
      setLoading(false);
    } else {
      const result = await requestData(`/orders`);
      setOrders(result);
      setFiltredOrders(result);
      setLoading(false);
    }
  };

  const handleChange = ({target}) => {
    const { name, value } = target;

    switch (name) {
      case 'id-filter':
        const filtred = orders.filter((e) => e._id.includes(value));
        setId(value);
        setFiltredOrders(filtred);
        break;    
      default:
        break;
    }
  };

  useEffect(() => {
    const data = JSON.parse(sessionStorage.getItem('login'));
    if (data) {
      getOrders(data);
    }
  }, []);

  return (
    <main className="page-container">
      <label className="form-label center">
        Buscar por ID:
        {' '}
        <input
          name="id-filter"
          type="text"
          className="form-input"
          value={id}
          onChange={(e) => handleChange(e)}
        />
      </label>
      {
        !loading ? <OrderList list={filtredOrders} /> : null
      }
    </main>
  )
};

export default Orders;
